import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { TemplateType } from "@xapp/ovai-lib";

import { AvailableAppsSummary, getOrgId, OrganizationId } from "api";
import { Credentials } from "auth";
import { State } from "redux/state";

export type FetchAvailableAppsSummary = "FETCH_AVAILABLE_APPS_SUMMARY";
export const FETCH_AVAILABLE_APPS_SUMMARY: FetchAvailableAppsSummary = "FETCH_AVAILABLE_APPS_SUMMARY";
export type FetchAvailableAppsSummaryEnd = "FETCH_AVAILABLE_APPS_SUMMARY_END";
export const FETCH_AVAILABLE_APPS_SUMMARY_END: FetchAvailableAppsSummaryEnd = "FETCH_AVAILABLE_APPS_SUMMARY_END";

export interface FetchAvailableAppsSummaryAction extends Action {
    payload: {
        organizationId: string;
        template: TemplateType;
        credentials: Credentials;
    };
    type: FetchAvailableAppsSummary;
}

export function fetchAvailableApps(
    organization: OrganizationId,
    template: TemplateType
): ThunkAction<void, State, undefined, FetchAvailableAppsSummaryAction> {
    return (dispatch: Dispatch<FetchAvailableAppsSummaryAction>, getState) => {
        const state = getState();
        dispatch(fetchAvailableAppsWithCredentials(organization, template, state.auth.credentials));
    };
}

function fetchAvailableAppsWithCredentials(
    organizationId: OrganizationId,
    template: TemplateType,
    credentials: Credentials
): FetchAvailableAppsSummaryAction {
    return {
        payload: {
            credentials,
            organizationId: getOrgId(organizationId),
            template
        },
        type: FETCH_AVAILABLE_APPS_SUMMARY
    };
}

export interface FetchAvailableAppsSummaryEndAction extends Action {
    payload: {
        organizationId: string;
        summary?: AvailableAppsSummary;
        error?: Error;
    };
    type: FetchAvailableAppsSummaryEnd;
}

export function fetchAvailableAppsSummaryEnd(
    error: Error,
    organizationId: string,
    summary?: AvailableAppsSummary
): FetchAvailableAppsSummaryEndAction {
    return {
        payload: {
            error,
            organizationId,
            summary
        },
        type: FETCH_AVAILABLE_APPS_SUMMARY_END
    };
}
